import commonFunctions from '../common/commonFunc.js';
export default {
}